import React from "react";
import { Typography } from "@mui/material";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";

import OrderTabs from "../Components/Order/OrderTabs";

import styles from "../Components/Order/OrderTabs.module.css";

const OrderPage = () => {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div>
          <h1 className={styles.title}>
            <ListAltOutlinedIcon />
            Manage Orders
          </h1>
          <p className={styles.subtitle}>
             View order status, process requests, and keep operations running smoothly.
          </p>
        </div>
      </div>

      <OrderTabs />
    </div>
  );
};

export default OrderPage;
